module.exports = __webpack_public_path__ + "static/media/about-me-etc03.a2bff476.jpeg";